<div class="modal-container">
    <div class="modal-header">
      <div class="header-content">
        <mat-icon class="header-icon">attach_file</mat-icon>
        <h2 class="modal-title">Attach Template</h2>
      </div>
      <button mat-icon-button (click)="onClose()" class="close-button" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="modal-content">
      
      
      <div class="form-group">
        <label class="select-label">Template</label>
        <ng-select
          [items]="templates"
          bindLabel="name"
          bindValue="id"
          placeholder="Select a template..."
          [(ngModel)]="selectedTemplate"
          class="modal-ng-select"
          [clearable]="false"
          [searchable]="true"
          (search)="onSearch($event.term)"
          [loading]="isLoading"
          [virtualScroll]="true"
          [selectOnTab]="true"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="template-option">
              <span class="template-name">{{item.name}}</span>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp>
            <div class="no-results">
              <mat-icon>search_off</mat-icon>
              <p>No templates found</p>
            </div>
          </ng-template>
          <ng-template ng-loadingtext>
            <div class="loading-options">
              <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
              <span>Loading templates...</span>
            </div>
          </ng-template>
        </ng-select>
        <p class="subtitle">
        <mat-icon class="subtitle-icon">info_outline</mat-icon>
          Select a template to attach to this project
          </p>
      </div>
    </div>
    
    <div class="modal-actions">
      <!-- <button mat-stroked-button (click)="onCancel()" class="cancel-button">
        <mat-icon>close</mat-icon>
        <span>Cancel</span>
      </button> -->
      <button 
        mat-flat-button 
        color="primary" 
        (click)="onAttach()"
        [disabled]="!selectedTemplate"
        class="attach-button"
      >
        <mat-icon>attach_file</mat-icon>
        <span>Attach Template</span>
      </button>
      <button 
        mat-flat-button 
        color="primary" 
        (click)="onAttach()"
        class="attach-button"
      >
        <mat-icon>attach_file</mat-icon>
        <span>Custom and Attach</span>
      </button>
    </div>
    </div>